var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOffroadBlue = function SvgOffroadBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85.807,
    height: 40.779,
    viewBox: "0 0 85.807 40.779",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    transform: "translate(-919.27 -500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(933.586 524.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M951.6,535.289a5.677,5.677,0,0,0-1.615-1.038,7.715,7.715,0,0,0-6.839,0,8.129,8.129,0,0,0-4.569,7.189c0,.261.053.508.077.763.016.173.025.349.053.52s.053.349.093.518a7.967,7.967,0,0,0,15.531,0c.039-.17.064-.344.093-.518s.036-.346.053-.52c.025-.255.077-.5.077-.763A7.942,7.942,0,0,0,951.6,535.289Zm.075,6.914a5.227,5.227,0,0,1-.1.52,5.055,5.055,0,0,1-.161.518,5.16,5.16,0,0,1-9.691,0,5.083,5.083,0,0,1-.161-.518,5.264,5.264,0,0,1-.1-.52,5.177,5.177,0,1,1,10.3-.763A5.086,5.086,0,0,1,951.675,542.2Z",
    transform: "translate(-938.578 -533.452)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(980.775 524.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M1015.246,535.289a5.683,5.683,0,0,0-1.614-1.038,7.717,7.717,0,0,0-6.84,0,8.06,8.06,0,0,0-.954.518,8.619,8.619,0,0,0-3.615,6.671c0,.261.053.508.077.763.017.173.025.349.053.52s.053.349.093.518a7.967,7.967,0,0,0,15.531,0c.039-.17.064-.344.093-.518s.036-.346.053-.52a7.625,7.625,0,0,0,.077-.763A7.942,7.942,0,0,0,1015.246,535.289Zm.075,6.914a5.227,5.227,0,0,1-.1.52,5.026,5.026,0,0,1-.162.518,5.16,5.16,0,0,1-9.691,0,5.083,5.083,0,0,1-.161-.518,5.178,5.178,0,1,1,10.193-1.283A5.086,5.086,0,0,1,1015.32,542.2Z",
    transform: "translate(-1002.223 -533.452)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(926.968 502.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M938.156,536.519h-8.475a6.18,6.18,0,0,0,5.969,5.748l-.406-.7Z",
    transform: "translate(-929.66 -512.408)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M992.7,536.519H958.129l2.912,5.044-.417.723h29.581l-.417-.723Z",
    transform: "translate(-937.016 -512.408)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M1000.35,521.841h4.806v-.328a2,2,0,0,0-1.841-1.983l-12.7-.948a4.58,4.58,0,0,1-3.067-1.5l-4.631-5.1c-1.9-2.09-4.143-5.031-6.591-6.334-3.493-1.86-7.413-1.648-11.442-1.648H934.759a4.248,4.248,0,0,0-4.217,3.908l-.56,12.17h2.27a.433.433,0,0,1,0,.866h-2.31l-.131,2.85h2.338a.433.433,0,0,1,0,.867h-2.378l-.118,2.576h9l1.2-2.075h9.221l1.2,2.075h35.571l1.2-2.075h9.221l1.2,2.075h7.7v-4.538h-4.806a.433.433,0,0,1,0-.867ZM954.7,517.029H933.33a.433.433,0,0,1,0-.866H954.7a.433.433,0,0,1,0,.866Zm0-2.967H933.432a.433.433,0,1,1,0-.866H954.7a.433.433,0,0,1,0,.866Zm0-2.968H933.534a.433.433,0,1,1,0-.866H954.7a.433.433,0,1,1,0,.866Zm0-2.968h-21.06a.433.433,0,0,1,0-.866H954.7a.433.433,0,0,1,0,.866Zm7.732-1.308V518l-2.534.009h0a.995.995,0,0,1-.993-.993l.005-10.2m3.751,15.476h-2.245a.433.433,0,1,1,0-.866h2.245a.433.433,0,1,1,0,.866Zm21.1-4.587a.357.357,0,0,1-.329.214l-19.618.07V506.818h1.32c3.661,0,7.2-.264,10.309,1.518,1.991,1.143,3.806,3.851,5.345,5.625l2.916,3.36A.359.359,0,0,1,983.751,517.707Z",
    transform: "translate(-929.653 -504)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1196",
    "data-name": "Rectangle 1196",
    width: 6.673,
    height: 17.795,
    rx: 3.336,
    transform: "translate(920.365 507.226) rotate(3.53)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M1030.839,527a.741.741,0,0,0-.741.741v6.737l-1.123,1.123v-1.543h-7.2l2.912,5.044-.417.723h1.332a3.364,3.364,0,0,0,2.955-1.779.73.73,0,0,0,.211-.141l2.812-2.812v-7.351A.741.741,0,0,0,1030.839,527Z",
    transform: "translate(-26.504 -6.981)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 30.399,
    height: 1.483,
    rx: 0.741,
    transform: "translate(933.157 500)",
    fill: "#06016c"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffroadBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/offroadBlue.56354204.svg";
export { ForwardRef as ReactComponent };